import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogFooter,
  AlertDialogTitle,
  AlertDialogDescription,
  AlertDialogAction,
  AlertDialogCancel,
} from "@/components/ui/alert-dialog";

export interface ConfirmDialogProps {
  isOpen: boolean;
  onClose: () => void;
  /** Dialog title (e.g. "Excluir entrada") */
  title: string;
  /** Body message */
  message: string;
  /** Confirm button label (e.g. "EXCLUIR") */
  confirmLabel: string;
  /** Label when confirm action is in progress (e.g. "EXCLUINDO...") */
  confirmLoadingLabel?: string;
  onConfirm: () => void | Promise<void>;
  loading?: boolean;
  /** When true, confirm button uses destructive (red) styling. Default true. */
  destructive?: boolean;
}

export default function ConfirmDialog({
  isOpen,
  onClose,
  title,
  message,
  confirmLabel,
  confirmLoadingLabel,
  onConfirm,
  loading = false,
  destructive = true,
}: ConfirmDialogProps) {
  const handleConfirm = async (e: React.MouseEvent) => {
    e.preventDefault();
    await onConfirm();
  };

  const confirmDisplay = loading && confirmLoadingLabel ? confirmLoadingLabel : confirmLabel;

  return (
    <AlertDialog
      open={isOpen}
      onOpenChange={(open) => {
        if (!open && !loading) onClose();
      }}
    >
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>{title}</AlertDialogTitle>
          <AlertDialogDescription>{message}</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogAction
            destructive={destructive}
            disabled={loading}
            onClick={handleConfirm}
          >
            {confirmDisplay}
          </AlertDialogAction>
          <AlertDialogCancel disabled={loading}>
            CANCELAR
          </AlertDialogCancel>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
